 export enum ActionAbsencesEnum {
ValiderAbsenceParGestionnaire = 0,
ValiderAbsenceParResponsableNiveau_1 = 1,
ValiderAbsenceParResponsableNiveau_2 = 2,
DemanderAnnulerAbsenceParSalarie = 3,
AnnulerAbsenceParGestionnaire = 4,
AnnulerAbsenceParResponsableNiveau_1 = 5,
AnnulerAbsenceParResponsableNiveau_2 = 6,
RefuserAbsenceParGestionnaire = 7,
RefuserAbsenceParResponsable = 8,
AnnulerDemandeAnnulationAbsenceParGestionnaire = 9,
RefuserAnnulationAbsenceParResponsable = 10,
AnnulerDemandeAnnulationAbsenceParSalarie = 11,
EnregistrerModifierAbsence = 12,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/ActionAbsencesEnum.ts